@if (showDebugInfo()) {
  <div>
    <div class="row">declaredDate: {{ declaredDate || 'null' }}</div>
    <div class="row">originallyDeclaredDate: {{ originallyDeclaredDate || 'null' }}</div>
    <div class="row">planningHistory?.length: {{ planningHistory?.length || 0 }}</div>
    @for (item of planningHistory; track item; let i = $index) {
      <div>
        <div class="row"><b>planningHistory[{{ i }}]</b></div>
        <div class="row">proposedTime: {{ item.proposedTime || 'null' }}</div>
        <div class="row">reason: {{ item.reason || 'null' }}</div>
        <div class="row">source: {{ item.source || 'null' }}</div>
        <div class="row">timestamp: {{ item.timestamp || 'null' }}</div>
      </div>
    }
  </div>
}
@if (displayPlanningHistory()) {
  <div class="alert alert-warning fade show" role="alert">
    <div class="row">
      <div class="col-md-1 d-flex align-items-center justify-content-center">
        <i class="fa fa-light fa-circle-exclamation" style="font-size: xx-large"></i>
      </div>
      <div class="col-md-11">
        Your order of the {{ this.movementSpecifiers[0].toLowerCase() }} movement has been confirmed but the
        {{ this.movementSpecifiers[1] }} time of <b>{{ originallyDeclaredTime }}</b> has been changed by
        <b>{{ totalShiftDuration }}</b>.
        <br>
        <br>
        <div class="planning-history-list">
          @for (item of planningHistory; track item; let i = $index) {
            <div class="planning-history-list-item">
              <div class="planning-history-list-item-field">{{ this.getSource(item.source) }}</div>
              <div>{{ this.proposedTimeAndGapArray[i] }}</div>
              <div class="planning-history-list-item-field">{{ item.reason }}</div>
            </div>
          }
          <div class="planning-history-list-item">
            <div class="planning-history-list-item-field">Requested time</div>
            <div>{{ this.proposedTimeAndGapArray[this.proposedTimeAndGapArray.length - 1] }}</div>
            <div class="planning-history-list-item-field"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
